import Service from './service.js';
import { PayOne } from '../global/payone.js';
import { IbanCalculator } from '../global/ibancalculator.js';

export class Payment extends Service {
    constructor(creditcarddata) {
        super('#form-service-payment', 'payment');
        this.Payone = new PayOne(creditcarddata);
        this.clearingtype = document.querySelector('#payment-clearingtype');
        this.subservices = document.querySelectorAll('.subservice');
        this.iban = document.querySelector('#payment-iban');
        this.pseudocardpan = document.querySelector('#payment-pseudocardpan');

        this.initService();
    };

    initService() {
        this.Payone.success = (response => {
            if(response.status == 'ok') {
                this.pseudocardpan.value = response.pseudocardpan;
                this.validated = true;
                this.submit();
            }
        });
        
        let ibanCalculator = new IbanCalculator('#payment-accountnumber', '#payment-bankcode');

        ibanCalculator.addEventListener('updateIban', event => {
            this.iban.setAttribute('placeholder', event.detail.placeholder);
            this.iban.value = event.detail.value;
            this.iban.dispatchEvent(new Event('input', {bubbles:true}));
        });

        if (this.iban) {
            this.iban.addEventListener('input', () => {
                this.iban.value = OVS.app.helper.formatIBAN(this.iban.value);
            });
        }
        
        if(this.clearingtype) {
            this.clearingtype.addEventListener('change', event => {
                this.updateClearingType();
            });
        }

        this.updateClearingType();
    };
    
    submit(event) {
        OVS.app.helper.toggleButton(true);
        if(typeof event !== 'undefined') {
            event.preventDefault();
        }
        if(!this.validated) {
            if(this.clearingtype.value == 'creditcard') {
                this.Payone.checkCreditCard();
            } else {
                OVS.app.helper.toggleButton(false);
                this.validate();
            }
        } else {
            let request = new Request('POST', this.form.getAttribute('action'));
            request.formData = this.form;
            request.call(response => {
                if(response.status == 'ok') {
                    window.location.replace(response.redirect);
                }
            });
        }
    };

    updateClearingType() {
        this.subservices.forEach(node => {
            node.classList.add('d-none');
        });
        
        if(this.clearingtype.value != "") {
            let subservice = document.querySelector('#' + this.clearingtype.value);
            if(subservice) {
                subservice.classList.remove('d-none');
            }
        }

        if(this.clearingtype.value == "creditcard") {
            this.Payone.initCreditCard();
        }
    };
};
